import { useSyncExternalStore } from 'react';

import { simulatorStore } from '@/dev/billing-simulator/store';

type SimulatedRole = 'org:member' | null;

const subscribe = (listener: () => void) =>
  simulatorStore().subscribe(listener);
const simulatedRole = (): SimulatedRole =>
  simulatorStore().getState().actAsMember ? 'org:member' : null;
const scenarioActive = (): boolean =>
  simulatorStore().getState().scenarioId !== null;

const noSubscription = () => () => {};
const noRole = (): SimulatedRole => null;
const never = () => false;

/**
 * The Clerk role the dev billing simulator stands in for: `'org:member'`
 * while its "Act as member (not admin)" is on, otherwise null. Read it before
 * the real role wherever the role gates billing:
 * `useSimulatedMemberRole() === 'org:member' || <the real check>`.
 *
 * Always null in a production build: `import.meta.env.DEV` compiles to
 * `false`, so the simulator's store is never read and the bundler drops it.
 */
export function useSimulatedMemberRole(): SimulatedRole {
  return useSyncExternalStore(
    import.meta.env.DEV ? subscribe : noSubscription,
    import.meta.env.DEV ? simulatedRole : noRole
  );
}

/**
 * Whether billing reads answer from a dev simulator scenario rather than the
 * API. Anything that copies the plan to another system skips it while this
 * holds, so a scenario never lands on the real organization's record. Always
 * false in a production build, for the same reason as above.
 */
export function useSimulatedBilling(): boolean {
  return useSyncExternalStore(
    import.meta.env.DEV ? subscribe : noSubscription,
    import.meta.env.DEV ? scenarioActive : never
  );
}
